module.exports = __webpack_public_path__ + "img/Vision strategy values Icon - white.3d0eba80.svg";